import * as React from 'react'
import { cn } from '../../lib/utils'

const sizeClasses = {
  sm: 'h-4 w-4',
  md: 'h-6 w-6',
  lg: 'h-8 w-8',
} as const

interface SpinnerProps extends React.ComponentPropsWithoutRef<'div'> {
  size?: keyof typeof sizeClasses
}

const Spinner = React.forwardRef<React.ComponentRef<'div'>, SpinnerProps>(
  ({ className, size = 'md', ...props }, ref) => (
    <div
      data-figma-component="Spinner"
      ref={ref}
      role="status"
      aria-label="Loading"
      className={cn(
        'animate-spin rounded-full border-2 border-current border-t-transparent',
        sizeClasses[size],
        className
      )}
      {...props}
    >
      <span className="sr-only">Loading...</span>
    </div>
  )
)
Spinner.displayName = 'Spinner'

export { Spinner }
export type { SpinnerProps }
